import { useMemo, useState } from 'react'
import { api, ROUTES } from './api'
import { useAdmin, useAsync, Pager, ErrorState, Loading, Empty, PageHead, dateFmt, stars } from './ui'

const PER = 10

export default function Reviews() {
  const { toast, confirm } = useAdmin()
  const { data, loading, error, reload } = useAsync(() => api.get(ROUTES.adminReviewsAll))
  const [rating, setRating] = useState('')
  const [page, setPage] = useState(1)
  const reviews = data || []
  const filtered = useMemo(() => reviews.filter((r) => !rating || String(r.rating) === rating), [reviews, rating])

  const remove = async (r) => {
    if (!(await confirm({ title: 'Delete review', body: 'Delete this review? Customers will no longer see it on the product page.' }))) return
    try {
      await api.del(`${ROUTES.adminReviews}/${r.id}`)
      toast('Review deleted')
      reload()
    } catch (e) {
      toast(e.message, 'err')
    }
  }

  if (error) return <ErrorState error={error} endpoint={`GET ${ROUTES.adminReviews}`} onRetry={reload} />

  return (
    <>
      <PageHead title="Reviews" sub="Moderate what customers say about your products." />
      <div className="toolbar">
        <select className="input" value={rating} onChange={(e) => { setRating(e.target.value); setPage(1) }}>
          <option value="">All ratings</option>
          {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} stars</option>)}
        </select>
      </div>
      {loading ? <Loading /> : filtered.length === 0 ? <Empty title="No reviews found" /> : (
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Product</th><th>Rating</th><th>Review</th><th>By</th><th>Date</th><th></th></tr></thead>
            <tbody>
              {filtered.slice((page - 1) * PER, page * PER).map((r) => (
                <tr key={r.id}>
                  <td>{r.product}</td>
                  <td><span className="stars" aria-label={`${r.rating} out of 5`}>{stars(r.rating)}</span></td>
                  <td className="wrap">{r.text || <span className="muted">No text</span>}</td>
                  <td>{r.name ?? r.user ?? '-'}</td>
                  <td>{dateFmt(r.createdAt)}</td>
                  <td className="actions"><button className="btn sm danger-ghost" onClick={() => remove(r)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Pager page={page} total={filtered.length} per={PER} onPage={setPage} />
    </>
  )
}
